// Mock data for BriefingIQ website
import {
  Target,
  Lightbulb,
  Shield,
  Sparkles,
  Database,
  CalendarDays,
  Video,
  MonitorPlay,
  BarChart3,
} from 'lucide-react';

export const navigation = {
  products: [
    {
      title: 'BriefingIQ',
      subtitle: 'Executive Briefing Management',
      href: '#briefingiq',
    },
    {
      title: 'EventIQ',
      subtitle: 'Corporate Event Management',
      href: '#eventiq',
    },
  ],
  company: [
    { title: 'About Us', href: '#about' },
    { title: 'Contact', href: '#contact' },
    { title: 'Careers', href: '#careers' },
  ],
};

export const heroTags = [
  { label: 'BriefingIQ for Executive Briefings', color: '#34d4c9' },
  { label: 'EventIQ for Corporate Events', color: '#8b5cf6' },
  { label: 'AI-Powered Analytics', color: '#f59e0b' },
  { label: 'Salesforce & Outlook', color: '#3b82f6' },
  { label: 'Zoom & Teams', color: '#ec4899' },
  { label: 'Global Multi-Location', color: '#22c55e' },
];

export const heroStats = [
  { value: 'BriefingIQ', label: 'Executive Briefing Management' },
  { value: 'EventIQ', label: 'Corporate Event Management' },
  { value: 'AI', label: 'Powered Analytics' },
  { value: '24/7', label: 'Enterprise-Grade Support' },
];

export const products = [
  {
    id: 'briefingiq',
    name: 'BriefingIQ',
    tag: 'Executive Briefing Management',
    description:
      'Plan, coordinate, and execute executive briefing programs with end-to-end workflow automation. From customer visit scheduling to post-briefing follow-up and pipeline tracking, BriefingIQ centralizes every touchpoint so nothing falls through the cracks.',
    features: [
      'Multi-location briefing center management',
      'Customizable approval workflows and scheduling',
      'Customer portal with RSVP and document sharing',
      'Post-visit surveys and NPS feedback capture',
    ],
    cta: 'Explore BriefingIQ',
  },
  {
    id: 'eventiq',
    name: 'EventIQ',
    tag: 'Corporate Event Management',
    description:
      'Manage corporate events of any scale — from conferences and trade shows to team offsites and hybrid virtual events. EventIQ streamlines every detail from planning through execution with logistics coordination, attendee management, and real-time event analytics.',
    features: [
      'Conferences, summits, and trade show management',
      'Hybrid and virtual event support with Zoom and Teams',
      'Internal events: offsites, training, and all-hands',
      'Attendee registration and logistics coordination',
    ],
    cta: 'Explore EventIQ',
  },
];

export const capabilities = [
  {
    icon: Sparkles,
    title: 'AI-Powered Dashboards',
    description:
      'Practical AI insights across BriefingIQ and EventIQ that organize data, surface meaningful information, and present clear reports for better decision-making.',
  },
  {
    icon: Database,
    title: 'Salesforce CRM Integration',
    description:
      'Two-way sync of contacts, accounts, and opportunities. BriefingIQ and EventIQ both log activities and pipeline influence directly in your CRM.',
  },
  {
    icon: CalendarDays,
    title: 'Outlook & Exchange Integration',
    description:
      'Bi-directional calendar sync, automated meeting invites, and room booking — shared across BriefingIQ briefings and EventIQ events.',
  },
  {
    icon: Video,
    title: 'Zoom & Microsoft Teams',
    description:
      'Built-in video conferencing for BriefingIQ sessions and EventIQ hybrid events with automatic meeting creation and attendance tracking.',
  },
  {
    icon: MonitorPlay,
    title: 'Digital Signage with Zoom',
    description:
      'Dynamic welcome screens for BriefingIQ visitor arrivals and real-time room boards for EventIQ conferences that create a professional experience.',
  },
  {
    icon: BarChart3,
    title: 'Reporting & Analytics',
    description:
      'Executive-level dashboards for BriefingIQ and EventIQ with customizable reports and real-time KPI tracking for every stakeholder.',
  },
];

export const aboutValues = [
  {
    icon: Target,
    title: 'Mission-Driven',
    description:
      'We believe every executive briefing and corporate event is a strategic opportunity. Our mission is to give teams the tools to turn engagements into measurable business outcomes.',
  },
  {
    icon: Lightbulb,
    title: 'Innovation First',
    description:
      'From AI-powered analytics to predictive engagement insights, we continuously push the boundaries of what briefing and event management technology can do.',
  },
  {
    icon: Shield,
    title: 'Enterprise Ready',
    description:
      'Built for the scale and security demands of global enterprises. SOC 2 compliant architecture, role-based access control, and seamless integrations with the tools you already use.',
  },
];

export const platformStats = [
  { value: '100%', label: 'Cloud-Native Platform' },
  { value: '360°', label: 'Customer Journey View' },
  { value: 'AI', label: 'Powered Analytics' },
  { value: '24/7', label: 'Dedicated Support' },
];

export const marqueeItems = [
  'AI-powered briefings — pre-briefing packets, live recaps, and follow-ups on autopilot',
  'AI-powered events — attendee intelligence and portfolio analytics in real time',
  'BriefingIQ: AI-powered executive briefing management',
  'EventIQ: AI-powered corporate event management',
  'BriefingIQ + EventIQ — one AI platform for briefings & events',
  "Try your next briefing or event with us — it's on us",
];

export const footerLinks = {
  products: [
    { label: 'BriefingIQ', href: '#briefingiq' },
    { label: 'EventIQ', href: '#eventiq' },
    { label: 'Platform', href: '#platform' },
    { label: 'Integrations', href: '#integrations' },
  ],
  company: [
    { label: 'About Us', href: '#about' },
    { label: 'Careers', href: '#careers' },
    { label: 'Contact', href: '#contact' },
    { label: 'Blog', href: '#blog' },
  ],
  resources: [
    { label: 'Documentation', href: '#docs' },
    { label: 'Help Center', href: '#help' },
    { label: 'Case Studies', href: '#cases' },
    { label: 'API Reference', href: '#api' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '#privacy' },
    { label: 'Terms of Service', href: '#terms' },
    { label: 'Security', href: '#security' },
    { label: 'Cookie Policy', href: '#cookies' },
  ],
};
